module.exports = __webpack_public_path__ + "img/obra.466545f2.png";